import { ReactNode } from 'react';
import ChangeService from './message/change-service';
import InvalidQuote from './message/invalid-quote';
import { P2GDivider, P2GGrid } from '@parcel2go/core-ui';
import { QuoteError } from '~/lib/types/basket-types';

type Props = {
  quotes: ReactNode;
  errorMessages?: QuoteError[];
  intent?: 'SWITCH' | 'INVALID';
  onClose: () => void;
};

const ServiceSwitchWrapper: React.FC<Props> = ({ quotes, errorMessages, intent, onClose }) => (
  <P2GGrid container direction="column" spacing={4} dataTestId="service-switcher-quotes">
    {intent === 'INVALID' && <InvalidQuote onClose={onClose} errorMessages={errorMessages} />}
    {intent === 'SWITCH' && <ChangeService onClose={onClose} errorMessages={errorMessages} />}
    <P2GGrid item>
      <P2GDivider />
    </P2GGrid>
    <P2GGrid item>{quotes}</P2GGrid>
  </P2GGrid>
);

export default ServiceSwitchWrapper;
